module.exports = __webpack_public_path__ + "static/media/NS-Hero.55c82372.jpg";